const ghana = {
  "Greater Accra": {
    Accra: [
      "Osu",
      "Labone",
      "Airport Residential",
      "East Legon",
      "Cantonments",
      "Dansoman",
    ],

    Tema: [
      "Community 1",
      "Community 2",
      "Community 3",
      "Community 4",
    ],

    Ga: [
      "Madina",
      "Adenta",
      "Amasaman",
      "Ablekuma",
    ],
  },

  Ashanti: {
    Kumasi: [
      "Adum",
      "Suame",
      "Asokwa",
      "Tafo",
      "Kwadaso",
    ],

    Obuasi: [
      "Tutuka",
      "Anyinam",
      "Bediem",
    ],

    Ejisu: [
      "Ejisu Central",
      "Fumesua",
      "Besease",
    ],
  },

  Central: {
    "Cape Coast": [
      "Pedu",
      "Abura",
      "Bakaano",
    ],

    Winneba: [
      "South Campus",
      "North Campus",
      "New Winneba",
    ],
  },
};

export default ghana;